if (!customElements.get('shop-slider')) {
  class ShopSlider extends HTMLElement {
    constructor() {
      super();

      this.swiperOptions = {
        slidesPerView: this.getAttribute('js-slides-mobile') ?? 'auto',
        spaceBetween: Number(this.getAttribute('js-space-between') ?? 12),
        breakpoints: {
          768: {
            slidesPerView: this.getAttribute('js-slides-tablet'),
          },
          1024: {
            slidesPerView: this.getAttribute('js-slides-desktop'),
          }
        }
      }
    }

    initSlider(sliderOptions) {
      this.slider = new Swiper(this, sliderOptions);

      requestAnimationFrame(() => {
        const buttonsWrapper = this.section.querySelector('.swiper-buttons');
        if(buttonsWrapper) buttonsWrapper.style.display = '';
      });
    }

    connectedCallback() {
      this.section = this.closest('[js-section]');
      if(this.section) {
        this.swiperOptions['navigation'] = {
          prevEl: this.section.querySelector('.swiper-button--prev'),
          nextEl: this.section.querySelector('.swiper-button--next')
        }
      }

      window.addEventListener("shopify:section:load", () => {
        this.initSlider(this.swiperOptions);
      });

      this.initSlider(this.swiperOptions);
    }
  }

  customElements.define('shop-slider', ShopSlider);
}